import { atom, PrimitiveAtom } from 'jotai';
import { createContext, Dispatch, useContext } from 'react';

import { EmailSearchRequestDto, EmailsSortByDto, SortDirectionDto } from '@/api/generated';
import { emptyFunction } from '@/utils/emptyFunction.util.ts';
import { EmailsReducerAction } from '@/views/emails/context/EmailsContextProvider.tsx';

export const initialEmailsFolderState: EmailsFolderStateAtom = {
  page: 0,
  pageSize: 15,
  search: {},
  sortBy: EmailsSortByDto.Date,
  sortOrder: SortDirectionDto.Asc,
  total: 100,
  totalPages: 10,
  unreadOnly: false,
};

export const folderStateAtom: PrimitiveAtom<EmailsFolderStateAtom> = atom<EmailsFolderStateAtom>({
  ...initialEmailsFolderState,
});

export type EmailsContextProps = {
  emailsState: EmailsViewState;
  updateEmailState: Dispatch<EmailsReducerAction>;
};

export type EmailsFolderStateAtom = {
  nextPageLink?: string;
  page: number;
  pageSize: number;
  search: EmailSearchRequestDto;
  sortBy: EmailsSortByDto;
  sortOrder: SortDirectionDto;
  total?: number;
  totalPages?: number;
  unreadOnly: boolean;
};

export type EmailsViewState = {
  selectedBox: { folderId: string } | null;
  selectedEmail: string | null;
  selectedThread: string | null;
};

const initialEmailsViewState: EmailsViewState = {
  selectedBox: null,
  selectedEmail: null,
  selectedThread: null,
};

export enum EMAILS_REDUCER_EVENT {
  SELECT_BOX = 'SELECT_BOX',
  SELECT_EMAIL = 'SELECT_EMAIL',
  SELECT_THREAD = 'SELECT_THREAD',
}

const EmailsContextDefaultValues: EmailsContextProps = {
  emailsState: initialEmailsViewState,
  updateEmailState: emptyFunction,
};
export const EmailsContext = createContext<EmailsContextProps>(EmailsContextDefaultValues);

export const useEmailsContext = (): EmailsContextProps => {
  return useContext<EmailsContextProps>(EmailsContext);
};
